<script>
import _ from "lodash";
import { mapGetters } from "vuex";
import TemplateIdBaseMixin from "@/components/mixins/TemplateIdBaseMixin";
import CreateAuditItemListManipulators from "@/utils/AuditItemListManipulator";
import { api as configApi } from "@/store/modules/configuration";

export default {
  mixins: [TemplateIdBaseMixin],
  data: () => ({}),
  computed: {
    ...mapGetters(configApi.namespace, [
      configApi.getters.getFindingsOrder,
      configApi.getters.getFindingTypes
    ]),
    templateItems() {
      return this.currentTemplate.audit_items;
    },
    templateItemManipulators() {
      const standard_id =
        this.standardId instanceof Array
          ? this.currentTemplate.standard[0]
          : this.currentTemplate.standard;
      let categories = {};

      if (standard_id in this.$store.state.configuration.categories) {
        categories = _.keyBy(
          this.$store.state.configuration.categories[standard_id],
          "id"
        );
      }

      return CreateAuditItemListManipulators(
        categories,
        this.getFindingsOrder,
        this.getFindingTypes
      );
    }
  },
  methods: {}
};
</script>
